import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import {
  CHART_TYPES,
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "../../shared/constants/StyleConstants";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import {
  ACTIONS,
  GENERAL_RULES_CONSTANTS,
  GENERAL_RULES_FILTERS_LIST,
  RULES_ACCESS,
  RULE_NEW,
  SAVE_GENERAL_RULE_ID
} from "./constants/GeneralRulesConstants";
import SaveGeneralRules from "./components/SaveGeneralRules/SaveGeneralRules.vue";
import { GeneralRulesService } from "./services/GeneralRulesService";
import { Http } from "@status/codes";
import { ChartRenderData } from "../Dashboards/AdminDashboard/models/ChartRenderData";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import store from "@/store";
import HorizontalBarChart from "../Dashboards/AdminDashboard/components/Charts/HorizontalBar/HorizontalBarChart.vue";
import BarChart from "../Dashboards/AdminDashboard/components/Charts/Bar/BarChart.vue";
import DoughnutChart from "../Dashboards/AdminDashboard/components/Charts/Doughnut/DoughnutChart.vue";
import PieChart from "../Dashboards/AdminDashboard/components/Charts/Pie/PieChart.vue";
import LineChart from "../Dashboards/AdminDashboard/components/Charts/Line/LineChart.vue";
import { SearchContext } from "@/shared/models/SearchContext";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { GeneralRule } from "./models/GeneralRule";
import { RulesQuery } from "./models/RulesQuery.model";
import { Response } from "@/shared/models/Response";
import { RulesResponse } from "./models/RulesResponse.model";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import { CrudChartData } from "@/shared/models/CrudChartData";
import { Utils } from "@/shared/utils/utils";
import { CrudChartRenderData } from "../Dashboards/AdminDashboard/models/CrudChartRenderData";
import { NavigationGuardNext, Route } from "vue-router";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import Vuetify from "vuetify";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { AxiosError } from "axios";

Vue.use(Vuetify);
Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "GeneralRules",
  components: {
    CrudChart,
    SaveGeneralRules,
    LineChart,
    PieChart,
    DoughnutChart,
    BarChart,
    HorizontalBarChart,
    ModalTemplate,
    EmptyState
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView",
      dataToLateralMenu: "getDataToLateralMenu",
      dashboardSearchName: "getDashBoardNameSearch"
    })
  }
})
export default class GeneralRules extends Vue {
  @Inject() generalRulesService!: GeneralRulesService;

  dataToMainView!: MenuDataStructure;
  dashboardSearchName!: string;

  btnClassPrimaryRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  admin = false;
  OPERATIONS: string[] = [];
  filterArray = GENERAL_RULES_FILTERS_LIST.MAIN;
  isVisibleSaveGeneralRules = false;
  tooltipAddButton: string = ACTIONS.ADD_RULE;
  newRule = false;
  changeItem = false;
  isLoadingCharts = true;
  chartDataGroupName: ChartRenderData = {
    labels: [],
    datasets: [
      {
        data: []
      }
    ]
  };
  showCharts = false;
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  chartTypes = CHART_TYPES;
  currentChartTypeIndex = 2;
  currentChartType = CHART_TYPES[this.currentChartTypeIndex].value;
  cardClass = STYLE_CLASSES.CARD;

  TITLE_PAGE = GENERAL_RULES_CONSTANTS.TITLE_PAGE;
  CLICK_ACTION = LIST_DATA_EVENTS.EDIT_DATA;
  EMPTY_STATE = FORM_MESSAGES.INFO_MESSAGE;

  loadingData = false;
  rulesList: Array<GeneralRule> = [];
  canSearch = true;
  resetKey = 0;
  docRef = "";
  filterQuery: RulesQuery = {};
  dataToChart?: CrudChartRenderData = CHART_INIT;
  ruleToEdit?: GeneralRule = RULE_NEW;
  PAGE_TITLE = GENERAL_RULES_CONSTANTS.PAGE_TITLE;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  GENERAL_RULES_FILTERS_LIST: any;

  mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);
    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }
    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.RULE
    );
    this.OPERATIONS.push(LIST_DATA_EVENTS.DUPLICATE_DATA);
    this.searchRules(true);
    this.emitSearchInitializer();
  }

  emitSearchInitializer() {
    this.initializeFilters();
    const searchContext: SearchContext = {
      title: GENERAL_RULES_CONSTANTS.PAGE_TITLE_SEARCH,
      filterArray: [this.filterArray],
      operations: this.OPERATIONS,
      clickAction: this.CLICK_ACTION,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.RULE,
      descriptions: [
        GENERAL_RULES_CONSTANTS.STATE,
        GENERAL_RULES_CONSTANTS.COLLECTION_NAME
      ],
      textButtonCreate: ACTIONS.ADD_RULE
    };

    const data = {
      ...searchContext
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      data
    );
  }

  initializeFilters() {
    this.filterArray.secondaryFilters = [];
    this.filterArray.secondaryFilters.push(
      GENERAL_RULES_FILTERS_LIST.SECONDARY.NAME
    );
    this.filterArray.secondaryFilters.push(
      GENERAL_RULES_FILTERS_LIST.SECONDARY.COLLECTION
    );
    this.filterArray.secondaryFilters.push(
      GENERAL_RULES_FILTERS_LIST.SECONDARY.STATE
    );
  }

  handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.changeItemConfirmation(itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteRule(itemId);
        this.actionCancel();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateRuleById(itemId, STATE.ACTIVE);
        this.actionCancel();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateRuleById(itemId, STATE.INACTIVE);
        this.actionCancel();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.actionCancel();
        break;
      case LIST_DATA_EVENTS.DUPLICATE_DATA:
        this.duplicateRuleById(itemId);
        this.actionCancel();
        break;
    }
  }
  async updateStateRuleById(id: string, state: string) {
    try {
      const responseData = await this.generalRulesService.updateStateRuleById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.searchRules(true);
      } else Snackbar.popError(responseData.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + RULES_ACCESS.PUT);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async duplicateRuleById(id: string) {
    try {
      const responseData = await this.generalRulesService.duplicateRuleById(id);
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.searchRules(true);
        this.changeItemConfirmation(responseData.data as string);
      } else Snackbar.popError(responseData.message);
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  clickData(event: string) {
    const findKeyService = [...GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES].find(
      item => item.name === event
    );
    this.filterQuery = {
      collection: [findKeyService ? findKeyService.key : ""]
    };
    this.searchRules(true);
  }

  clickOut() {
    this.filterQuery = {};
    this.searchRules(true);
  }

  getDataChart(params: CrudChartData | undefined) {
    if (params) {
      this.isLoadingCharts = false;
      const collectionsToChart: any = {};
      for (const key in params.colecciones) {
        const findCollection = [
          ...GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES
        ].find(Collection => Collection.key === key);
        if (findCollection !== undefined) {
          collectionsToChart[findCollection.name] = params.colecciones[key];
        }
      }
      params.colecciones = collectionsToChart;
      this.chartDataGroupName = Utils.mapChartData(
        params,
        GENERAL_RULES_CONSTANTS.COLECTIONS
      );
      this.dataToChart = {
        chartTitle: GENERAL_RULES_CONSTANTS.RULES,
        chartRenderData: this.chartDataGroupName
      };
      this.showCharts = true;
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
    }
  }

  actionButtonAdd() {
    if (this.tooltipAddButton === ACTIONS.ADD_RULE) {
      this.newRule = !this.newRule;
      this.PAGE_TITLE = GENERAL_RULES_CONSTANTS.PAGE_TITLE_ADD;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
      );
      this.isVisibleSaveGeneralRules = true;
      this.goToStart(SAVE_GENERAL_RULE_ID);
      this.tooltipAddButton = ACTIONS.CANCEL;
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.changeItem = false;
      this.ruleToEdit = RULE_NEW;
    } else {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
    }
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  @Watch("dataToMainView")
  handleDataToMainView() {
    const validations: Record<string, void> = {
      Panel: this.panelValidation()
    };
    validations[this.dataToMainView.from];
  }

  panelValidation() {
    if (this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.filterQuery = this.dataToMainView.data;
          this.searchRules(true);
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.actionButtonAdd();
          break;
      }
    }
  }

  async searchRules(shouldSearch: boolean) {
    if (!shouldSearch) return;
    this.loadingData = true;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );

    this.rulesList = [];
    this.canSearch = false;
    const rulesResponse = await this.getData();

    if (rulesResponse.code === Http.Found && rulesResponse.data !== undefined) {
      this.rulesList = rulesResponse.data.rulesList;
      this.getDataChart(rulesResponse.data?.chartData);
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        this.rulesList
      );
      this.canSearch = true;
    } else {
      this.showCharts = false;
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      if (rulesResponse.code === Http.NotFound) {
        Snackbar.popInfo(rulesResponse.message);
      } else {
        Snackbar.popError(rulesResponse.message);
      }
    }
    this.dashboardSearchName && this.dashboardSearchName != ""
      ? this.editRule(this.rulesList[0]._key as string)
      : this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
          ""
        );

    store.commit(STORE_CONSTANTS.DASHBOARD_SEARCH_NAME, "");
    this.loadingData = false;
  }

  async getData(): Promise<Response<RulesResponse>> {
    try {
      this.loadingData = true;
      const response: Response<RulesResponse> = await this.generalRulesService.getGeneralRulesByFilters(
        this.dashboardSearchName && this.dashboardSearchName != ""
          ? { name: [this.dashboardSearchName] }
          : this.filterQuery !== undefined
          ? this.filterQuery
          : {}
      );
      this.loadingData = false;
      const setCollectionsNameToRules = response.data?.rulesList.map(
        element => {
          const findCollection = [
            ...GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES
          ].find(item => item.key === element.collection);
          if (findCollection !== undefined) {
            element.collectionName = findCollection.name;
          }
          return element;
        }
      );
      this.rulesList = setCollectionsNameToRules!;
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
        setCollectionsNameToRules
      );
      return response;
    } catch (error) {
      this.loadingData = false;
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      if ((error as AxiosError).response?.status == Http.Forbidden) {
        const RESPONSE_ERROR: Response<RulesResponse> = {
          code: Http.Forbidden,
          message: FORM_MESSAGES.FORBIDDEN_REQUEST + RULES_ACCESS.GET,
          data: { rulesList: [], chartData: {} }
        };
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + RULES_ACCESS.GET);

        return RESPONSE_ERROR;
      } else {
        const RESPONSE_ERROR: Response<RulesResponse> = {
          code: Http.BadRequest,
          message: FORM_MESSAGES.REQUEST_FAILED,
          data: { rulesList: [], chartData: {} }
        };
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
        return RESPONSE_ERROR;
      }
    }
  }

  changeItemConfirmation(ruleId: string) {
    this.changeItem = true;
    this.editRule(ruleId);
  }

  editRule(ruleId: string) {
    const findRule = this.rulesList.find(
      (rule: GeneralRule) => rule._key === ruleId
    );

    if (findRule !== undefined) {
      this.ruleToEdit = { ...findRule };
      this.isVisibleSaveGeneralRules = true;
      this.goToStart(SAVE_GENERAL_RULE_ID);
      this.sendDataToLateralMenu(
        PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
        ruleId
      );

      this.PAGE_TITLE = GENERAL_RULES_CONSTANTS.PAGE_TITLE_EDIT;
      this.tooltipAddButton = ACTIONS.CANCEL;
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
    }
  }

  ruleSaved() {
    this.changeItem = false;
    this.isVisibleSaveGeneralRules = false;
    this.searchRules(true);
    this.tooltipAddButton = ACTIONS.ADD_RULE;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.PAGE_TITLE = GENERAL_RULES_CONSTANTS.PAGE_TITLE;
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  actionCancel() {
    this.isVisibleSaveGeneralRules = false;
    this.tooltipAddButton = ACTIONS.ADD_RULE;
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.ruleToEdit = RULE_NEW;
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      ""
    );
    this.changeItem = false;
    this.PAGE_TITLE = GENERAL_RULES_CONSTANTS.PAGE_TITLE;
    this.resetKey = 1 - this.resetKey;
  }

  async deleteRule(ruleId: string) {
    try {
      const responseData = await this.generalRulesService.deleteRule(ruleId);
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.rulesList = this.rulesList.filter(item => {
          return item._key !== ruleId;
        });
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          this.rulesList
        );
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(responseData.message);
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + RULES_ACCESS.DELETE
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }
}
